// Founder Graph shim — re-export Bootpreneurs' existing i18next instance and
// register the EN/FR `community` namespace bundles shipped with Founder Graph.
import i18n from "@/i18n";
import enCommunity from "@/locales/en/community.json";
import frCommunity from "@/locales/fr/community.json";
import esCommunity from "@/locales/es/community.json";
import ptCommunity from "@/locales/pt/community.json";
import enVoiceAgent from "@/locales/en/voice-agent.json";
import frVoiceAgent from "@/locales/fr/voice-agent.json";
import esVoiceAgent from "@/locales/es/voice-agent.json";
import ptVoiceAgent from "@/locales/pt/voice-agent.json";

if (!i18n.hasResourceBundle("en", "community")) {
  i18n.addResourceBundle("en", "community", enCommunity, true, true);
}
if (!i18n.hasResourceBundle("fr", "community")) {
  i18n.addResourceBundle("fr", "community", frCommunity, true, true);
}
if (!i18n.hasResourceBundle("es", "community")) {
  i18n.addResourceBundle("es", "community", esCommunity, true, true);
}
if (!i18n.hasResourceBundle("pt", "community")) {
  i18n.addResourceBundle("pt", "community", ptCommunity, true, true);
}

if (!i18n.hasResourceBundle("en", "voice-agent")) {
  i18n.addResourceBundle("en", "voice-agent", enVoiceAgent, true, true);
}
if (!i18n.hasResourceBundle("fr", "voice-agent")) {
  i18n.addResourceBundle("fr", "voice-agent", frVoiceAgent, true, true);
}
if (!i18n.hasResourceBundle("es", "voice-agent")) {
  i18n.addResourceBundle("es", "voice-agent", esVoiceAgent, true, true);
}
if (!i18n.hasResourceBundle("pt", "voice-agent")) {
  i18n.addResourceBundle("pt", "voice-agent", ptVoiceAgent, true, true);
}

export default i18n;
